import {Component, Input, OnInit} from '@angular/core';
@Component({
    selector: 'app-timeline-tile',
    standalone: true,
    imports: [],
    templateUrl: './timeline-tile.component.html',
    styleUrl: './timeline-tile.component.scss'
})
export class TimelineTileComponent {
    @Input() eventName!: string;
    @Input() quantity!: string;
    @Input() dayNumber!: string;
    @Input() applyMethod!: string;
    @Input() assignedTo!: string;
}
